/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'clock': {
    width: 32,
    height: 32,
    viewBox: '0 0 32 32',
    data: '<g _stroke="none" stroke-width="1" _fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><g transform="translate(8 8)" _stroke="#00272E"><circle pid="0" cx="8.499" cy="8.501" r="8.146"/><polyline pid="1" points="8.5 4.604875 8.5 8.50070833 12.75 12.3965417"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/assets/icons/clock.js